<template>
  <div>
    <div style="margin-top: 40px; display: flex; gap: 30px; align-items: center">
      <el-button size="mini" @click="m__back_to_list">
        <strong><i style="font-weight: bold" class="el-icon-arrow-left"></i> {{ $t('base.back') }}</strong>
      </el-button>
      <strong style="font-size: 18px"> {{ $t('base.create_new_campaign') }} </strong>
    </div>

    <div style="margin-top: 50px">
      <strong style="font-size: 15px">{{ $t('base.basic_settings') }}</strong>

      <div style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">{{ $t('base.ad_name') }}</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center">
          <el-input v-model="campaign_info.name" size="mini" :placeholder="$t('input.ad_name')" style="width: 300px">
          </el-input>
        </div>
      </div>

      <div style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">{{ $t('base.tagline') }}</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center">
          <el-input v-model="campaign_info.tagline" size="mini" :placeholder="$t('input.tagline')" style="width: 300px">
          </el-input>
        </div>
      </div>

      <div style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">{{ $t('base.budget') }}</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center">
          <el-radio v-model="campaign_info.budget_type" label="unlimited">{{ $t('base.unlimited') }}</el-radio>
          <el-radio v-model="campaign_info.budget_type" label="daily_budget">{{ $t('base.daily_budget') }}</el-radio>
          <el-input v-if="campaign_info.budget_type === 'daily_budget'" v-model="campaign_info.daily_budget"
                    type="number" size="mini"></el-input>
        </div>
      </div>

      <div style="display: flex; margin-top: 30px;">
        <div style="width: 150px">
          <span style="font-size: 13px">{{ $t('base.duration') }}</span>
        </div>
        <div style="display: flex; gap: 10px; align-items: center">
          <el-radio v-model="campaign_info.campaign_time" label="unlimited">{{ $t('base.unlimited') }}</el-radio>
          <el-radio v-model="campaign_info.campaign_time" label="daterange">{{
              $t('base.set_start_end_date')
            }}
          </el-radio>
          <el-date-picker
            v-if="campaign_info.campaign_time === 'daterange'"
            v-model="campaign_info.campaign_date_range"
            type="daterange" range-separator="-"
            :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
            format="dd-MM-yyyy">
          </el-date-picker>
        </div>
      </div>
    </div>

    <div style="margin-top: 50px">
      <strong style="font-size: 15px">{{ $t('base.bidding') }}</strong>

      <div style="margin-top: 30px; display: flex; gap: 20px">

        <div
          style="max-width: 50%; border: 1px solid #e5e5e5; border-radius: 8px; padding: 20px; display: flex; flex-direction: column; gap: 10px; cursor: pointer"
          :style="config_campaign_price_type === 'manual' ? 'border: 1px solid #ee4d2d' : ''"
          @click="config_campaign_price_type = 'manual'">
          <div style="font-size: 14px">{{ $t('base.manual_bidding') }}</div>
          <div style="color: #999; font-size: 13px">
            {{ $t('base.optional_bidding') }}
          </div>
        </div>
      </div>
    </div>

    <template v-if="config_campaign_price_type === 'auto'">
      <div style="margin-top: 50px">
        <strong class="text-danger" style="font-size: 15px">*</strong>
        <strong style="font-size: 15px">
          {{ $t('base.target_roas') }}
        </strong>

        <div style="margin-top: 30px">
          <div>
            <el-radio v-model="form_update_target_broad_roi.type" :label="'auto'">
              {{ $t('create_ads.auto_bidding') }}
            </el-radio>
            <div>
              {{ $t('create_ads.auto_bidding_message') }}
            </div>
          </div>
          <div style="margin-top: 20px">
            <el-radio v-model="form_update_target_broad_roi.type" :label="'custom'">
              {{ $t('create_ads.manual_bidding') }}
            </el-radio>
            <div>
              {{ $t('base.set_your_own_roas') }}
            </div>
          </div>
          <div v-if="form_update_target_broad_roi.type === 'custom'"
               style="margin-top: 20px; padding-left: 10px; display: flex; flex-direction: column; gap: 10px">
            <div v-for="item in form_update_target_broad_roi.custom_type_list" :key="item" style="display: flex">
              <div style="width: 150px">
                <el-radio v-model="form_update_target_broad_roi.custom_type" :label="item">
                  ROAS = {{ item / 100000 }}
                </el-radio>
              </div>
              <div>

              </div>
            </div>
            <div style="display: flex">
              <div style="width: 150px">
                <el-radio v-model="form_update_target_broad_roi.custom_type" :label="'custom'">
                  {{ $t('create_ads.custom') }}
                </el-radio>
              </div>
              <div style="flex: 1; padding-right: 10px">
                <el-input type="number" v-model="form_update_target_broad_roi.custom_value" :min="1" :max="50"
                          size="mini" placeholder="1.0 ~ 50.0" style="width: 300px">
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="['all', 'search'].includes(campaign_info.campaign_type) && config_campaign_price_type === 'manual'">
      <div style="margin-top: 50px">
        <strong class="text-danger" style="font-size: 15px">*</strong>
        <strong style="font-size: 15px">
          {{ $t('ads.add_keywords') }}
        </strong>

        <div>
          <el-row style="margin-top: 10px">
            <el-col :sm="15" style="padding-right: 20px">
              <p class="text-title">{{ $t('base.keyword_selection') }}</p>
              <br>
              <div style="height: 50px; margin: 15px 0 0 0;">
                <div class="atosa-tab">
                  <div class="atosa-tab-item" :class="radio === '1' ? 'atosa-tab-item-active': ''" @click="radio = '1'">
                    {{ $t('base.shopee_recommend') }}
                  </div>
                  <div v-if="m__check_marketing_package('keyword_tool')"
                       class="atosa-tab-item" :class="radio === '4' ? 'atosa-tab-item-active': ''" @click="radio = '4'">
                    {{ $t('menu.atosa_keyword_tool') }}
                  </div>
                  <div class="atosa-tab-item" :class="radio === '2' ? 'atosa-tab-item-active': ''" @click="radio = '2'">
                    {{ $t('keyword.file') }} (Atosa)
                  </div>
                  <div class="atosa-tab-item" :class="radio === '3' ? 'atosa-tab-item-active': ''" @click="radio = '3'">
                    {{ $t('base.search_keywords') }}
                  </div>
                  <div class="atosa-tab-item" :class="radio === '5' ? 'atosa-tab-item-active': ''" @click="radio = '5'">
                    Import Excel
                  </div>
                  <br>
                </div>
              </div>

              <template v-if="radio === '1'">
                <div style="height: 24px; margin-top: 10px">
                </div>
                <el-table :data="c__shopee_keyword_display_list"
                          @sort-change="({prop, order}) => {shopee_filter.sort_option.order = order; shopee_filter.sort_option.prop = prop}">
                  <el-table-column
                    :label="$t('base.keyword')"
                    prop="keyword">
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.volume')"
                    prop="search_volume"
                    sortable="custom">
                    <template slot-scope="scope">{{ scope.row.search_volume | currency }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.relevance')" prop="relevance" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.relevance | currency }}/10</template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.recommend_price')" prop="recommend_price" sortable="custom">
                    <template slot-scope="scope">
                      <el-input size="mini" v-model="scope.row.recommend_price" type="number"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.action')"
                    align="right"
                    width="90px">
                    <template slot-scope="scope">
                      <div style="padding-top: 5px">
                        <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" type="text" class="text-info"
                                @click="m__add_keyword(scope.row, 'shopee_suggest_keywords')">
                          <strong>{{ $t('base.add') }} ></strong></strong>
                        <strong v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</strong>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="shopee_filter.current_page" :page-size="shopee_filter.page_size"
                               layout="prev, pager, next, total" :total="shopee_suggest_keywords.length"/>
              </template>

              <template v-if="radio === '2'">
                <div style="height: 35px;">
                  <el-row>
                    <el-col :sm="12">
                      <el-select size="mini" value="" v-model="selected_keyword_file"
                                 @change="m__get_keyword_file_detail"
                                 filterable :placeholder="$t('select.keyword_file')" style="width: 250px">
                        <el-option v-for="keyword in keyword_file_list" :key="keyword._id" :value="keyword._id"
                                   :label="keyword.filename"></el-option>
                      </el-select>
                      &nbsp;&nbsp;
                      <strong><a href="javascript:void(0)" style="color: orangered"
                                 @click="m__get_keyword_file">({{ $t('base.update') }})</a></strong>
                    </el-col>
                    <el-col :sm="12" class="text-right">
                      <el-select v-model="form_add_new_campaign.price_type" size="mini"
                                 style="border: none !important; width: 230px">
                        <el-option :value="'mipee'" :label="$t('base.use_saved_bid_price')"></el-option>
                        <el-option :value="'shopee'" :label="$t('base.use_shopee_bid_price')"></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </div>
                <el-table :data="c__mipee_keywords_display_list"
                          @sort-change="({prop, order}) => {mipee_filter.sort_option.order = order; mipee_filter.sort_option.prop = prop}">
                  <el-table-column :label="$t('base.keyword')" prop="keyword">
                    <template slot-scope="scope">{{ scope.row.keyword.normalize() }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.volume')" prop="search_volume" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.search_volume | currency }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.saved_bid_price')" prop="price" sortable="custom">
                    <template slot-scope="scope" slot="header">
                      {{ $t('base.saved_bid_price') }} <span v-if="form_add_new_campaign.price_type === 'mipee'"
                                                             style="color: red">*</span>
                    </template>
                    <template slot-scope="scope">
                      <el-input size="mini" type="number" :min="400" v-model="scope.row.price"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.shopee_bid_price')" prop="recommend_price" sortable="custom">
                    <template slot-scope="scope" slot="header">
                      {{ $t('base.shopee_bid_price') }} <span v-if="form_add_new_campaign.price_type === 'shopee'"
                                                              style="color: red">*</span>
                    </template>
                    <template slot-scope="scope">
                      <el-input size="mini" type="number" :min="400" v-model="scope.row.recommend_price"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.action')" width="90px" align="right">
                    <template slot-scope="scope">
                      <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" @click="m__add_keyword(scope.row)"
                              class="text-info">{{ $t('base.add') }} ></strong>
                      <strong v-else href="javascript:void(0)">{{ $t('base.added') }}</strong>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="mipee_filter.current_page" :page-size="mipee_filter.page_size"
                               layout="prev, pager, next, total" :total="mipee_suggest_keywords.length"/>
                <br>
              </template>

              <template v-if="radio === '3'">
                <div style="height: 35px;">
                  <el-autocomplete size="mini" :placeholder="$t('input.placeholder')" v-model="keyword"
                                   style="width: 250px" :fetch-suggestions="m__suggest_keyword"
                                   @select="m__search_sp_keyword"></el-autocomplete>
                </div>
                <el-table :data="c__search_keyword_display_list"
                          @sort-change="({prop, order}) => {search_keyword_filter.sort_option.order = order; search_keyword_filter.sort_option.prop = prop}">
                  <el-table-column :label="$t('base.keyword')" prop="keyword">
                    <template slot-scope="scope">{{ scope.row.keyword.normalize() }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.volume')" prop="sp_volume" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.sp_volume | currency }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.relevance')" prop="relevance" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.relevance | currency }}/10</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.recommend_price')" prop="sp_price" sortable="custom">
                    <template slot-scope="scope">{{ scope.row.sp_price | currency }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('base.action')" width="90px" align="right">
                    <template slot-scope="scope">
                      <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" @click="m__add_keyword(scope.row)"
                              class="text-info">{{ $t('base.add') }} ></strong>
                      <strong v-else href="javascript:void(0)">{{ $t('base.added') }}</strong>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="search_keyword_filter.current_page"
                               :page-size="search_keyword_filter.page_size"
                               layout="prev, pager, next, total" :total="search_keyword.length"/>
              </template>

              <template v-if="radio === '4'">
                <div style="height: 35px; margin-top: 9px">
                  <el-input size="mini" :placeholder="$t('input.placeholder')"
                            v-model="base_keyword" style="width: 250px" @keyup.enter.native="m__enter_input"></el-input>
                  <el-button size="mini" type="primary" icon="el-icon-search" :loading="fff_loading"
                             @click="m__try_get_keyword_result"> {{ $t('base.search') }}
                  </el-button>
                </div>
                <el-table :data="c__fff_result_display_list" @sort-change="m__fff_sort_change" class="fff-table">
                  <el-table-column :label="$t('base.keyword')" show-tooltip-when-overflow>
                    <template slot-scope="scope">
                      {{ scope.row.keyword.normalize() }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="sp_volume"
                    :label="$t('base.volume')" sortable="custom">
                    <template slot-scope="scope">
                      {{ scope.row.sp_volume | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="sp_price"
                    :label="$t('base.recommend_price')" sortable="custom">
                    <template slot-scope="scope">
                      {{ scope.row.sp_price | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.action')"
                    align="right" width="90px">
                    <template slot-scope="scope">
                      <div style="padding-top: 5px">
                        <strong v-if="m__can_add(scope.row)" href="javascript:void(0)" type="text" class="text-info"
                                @click="m__add_keyword(scope.row, 'shopee_suggest_keywords')">
                          <strong>{{ $t('base.add') }} ></strong></strong>
                        <strong v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</strong>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="atosa_keyword_filter.current_page"
                               :page-size="atosa_keyword_filter.page_size"
                               layout="prev, pager, next, total" :total="fff_result.length"/>
              </template>

              <el-row v-if="radio === '5'">
                <div style="height: 35px;">
                  <el-button size="mini" type="primary" icon="ti-harddrives" @click="m__show_import_excel_file">
                    &nbsp;&nbsp;&nbsp;{{ $t('base.import_excel_file') }}
                  </el-button>
                  &nbsp;&nbsp;&nbsp;<strong class="text-danger">*{{ $t('keyword.import_note') }}</strong>
                </div>
                <el-table
                  :data="c__excel_keyword_display_list">
                  <el-table-column
                    :label="$t('base.keyword')">
                    <template slot-scope="scope">
                      {{ scope.row.keyword.normalize() }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="search_volume"
                    :label="$t('base.volume')" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.search_volume | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="recommend_price"
                    :label="$t('base.recommend_price')" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.recommend_price | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('base.action')" width="90px"
                    align="right">
                    <template slot-scope="scope">
                      <div style="padding-top: 5px">
                        <a v-if="m__can_add(scope.row)" href="javascript:void(0)" type="text"
                           @click="m__add_keyword(scope.row, 'shopee_suggest_keywords')">
                          <strong>{{ $t('base.add') }} ></strong></a>
                        <a v-else href="javascript:void(0)" class="text-grey">{{ $t('base.added') }}</a>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="excel_keyword_filter.current_page"
                               :page-size="excel_keyword_filter.page_size"
                               layout="prev, pager, next, total" :total="excel_keyword.length"/>
              </el-row>

              <br>
              <el-button size="mini" type="primary" @click="m__add_all">
                {{ radio !== '4' ? $t('keyword.add_all') : $t('keyword.add_top_x', {x: '100'}) }}
              </el-button>
              &nbsp;
              &nbsp;
              &nbsp;
              <el-checkbox v-model="omit_duplicated_keyword">{{ $t('base.remove_duplicated_keywords') }}</el-checkbox>
            </el-col>

            <el-col :sm="9" style="padding-left: 20px">
              <p class="text-title"> {{ $t('keyword.added_keywords') }}</p>
              <br>

              <div style="height: 50px; margin: 15px 0 10px 0;">
                <el-row>
                  <el-col :sm="24">
                    <el-select v-model="form_add_new_campaign.match_type" size="mini" style="border: none !important;">
                      <el-option :value="0" :label="$t('keyword.exact')"></el-option>
                      <el-option :value="1" :label="$t('keyword.broad')"></el-option>
                    </el-select>
                    &nbsp;
                    <el-button size="mini" @click="m__show_update_keyword_dialog"> {{
                        $t('base.edit_bid_price')
                      }}
                    </el-button>
                    <el-button size="mini" type="info" @click="added_keyword = []">Clear</el-button>
                  </el-col>
                </el-row>
              </div>

              <div style="height: 35px; margin-top: 10px">
              </div>

              <el-table :data="c__added_keyword_display_list">
                <el-table-column
                  :label="$t('base.keyword')"
                  prop="keyword"
                  show-tooltip-when-overflow>
                </el-table-column>
                <el-table-column width="120px" :label="$t('base.bid_price')">
                  <template slot-scope="scope">
                    <el-input size="mini" v-model="scope.row.recommend_price" type="number"></el-input>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.action')" align="right" width="90px">
                  <template slot-scope="scope">
                    <div style="padding-top: 5px">
                      <a href="javascript:void(0)" type="text" class="text-danger"
                         @click="m__remove_keyword(scope.row)">
                        <strong> {{ $t('base.delete') }}</strong></a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination :current-page.sync="added_keyword_filter.current_page"
                             :page-size="added_keyword_filter.page_size"
                             layout="prev, pager, next, total" :total="added_keyword.length"/>

              <div class="text-right" style="margin-top: 10px">
                <el-button size="mini" type="primary" icon="ti-save"
                           @click="m__initial_save_keyword_file">{{ $t('keyword.save_file') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </template>

    <div style="margin: 50px 0" class="text-right">
      <el-button type="primary" size="medium" :loading="loading.create_campaign" icon="el-icon-check"
                 @click="m__confirm_create_new_product_campaign">{{ $t('base.create_new_campaign') }}
      </el-button>
    </div>

    <el-dialog :visible.sync="show_dialog.select_product" :close-on-click-modal="false"
               width="1000px">
      <div slot="title" style="padding: 0 10px 10px 10px">
        <strong style="font-size: 15px">
          {{ $t('ads.select_products_for_creating_ad').toUpperCase() }}
          <span v-if="!get_products" class="text-success">({{ $t('product.get_success') }})</span>
          <span v-else class="text-warning">(<i class="el-icon-loading"></i> {{ $t('base.loading_data') }}...)</span>
        </strong>
        <br>
        <br>

        <el-row>
          <el-col :sm="18">
            {{ $t('product.list') }} ({{ $t('base.selected') }} {{
              c__product_filter_list.filter(i => i.checked).length
            }})
          </el-col>
          <el-col :sm="6">
            <el-input size="mini" v-model="product_filter.keyword" :placeholder="$t('input.placeholder')"></el-input>
          </el-col>
        </el-row>

        <br>
        <el-table :data="c__product_display_list" @sort-change="m__product_sort_change"
                  @row-click="(row, column) => {if (column.label !== '#') {row.checked = !row.checked}}">
          <el-table-column label="#" width="40px">
            <template slot-scope="scope">
              <el-checkbox size="mini" v-model="scope.row.checked"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.image')" width="50px">
            <template slot-scope="scope">
              <template v-if="scope.row.images.length>0">
                <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="product_logo"
                     style="width:32px; height:32px; border-radius: 4px;"/>
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" prop="name" show-tooltip-when-overflow>
            <template slot-scope="scope">
              <a href="javascript:void(0)"
                 @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.id}`, shop)">
                {{ scope.row.name }}
              </a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="100px" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.price | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.monthly_sales')" prop="monthly_sales" width="130px" sortable="custom">
          </el-table-column>
          <el-table-column :label="$t('base.sales')" prop="revenue" width="130px" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.revenue | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="100px" sortable="custom">
          </el-table-column>
        </el-table>
        <br>
        <el-row>
          <el-col :sm="12">
            <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                           layout="prev, pager, next, total" :total="c__product_filter_list.length"/>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-button size="mini" type="primary" @click="m__confirm_select_product" icon="el-icon-check">
              {{ $t('base.confirm') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.shopee_result" :close-on-click-modal="false" custom-class="no-body"
               width="700px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('ads.create_campaigns_result') }}</strong>

        <div>
          <el-table :data="create_campaigns_result">
            <el-table-column :label="$t('base.product')" show-tooltip-when-overflow>
              <template slot-scope="scope">{{ scope.row.name }}</template>
            </el-table-column>
            <el-table-column :label="$t('base.status')">
              <template slot-scope="scope">
                <div v-if="scope.row.code === 0">
                  <strong class="text-success">{{ $t('base.create_campaign_success') }}</strong>
                </div>
                <div v-else>
                  <strong class="text-danger">{{ $t('ads.cannot_create_campaign') }}</strong>
                  <br>
                  <strong class="text-danger"> {{ $t('base.error_code') }}: {{ scope.row.code }}</strong>
                  <br>
                  <div v-for="item in scope.row.validation_error_list">
                    <strong v-if="typeof item === 'string'">{{ item }}</strong>
                    <strong v-if="typeof item === 'object'">field: {{ item.field }} - msg: {{ item.msg }}</strong>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button
            v-if="create_campaigns_result.filter(i => i.code === 0).length === create_campaigns_result.length"
            size="mini" type="primary" @click="show_dialog.shopee_result = false; m__back_to_list()">
            {{ $t('ads.back_to_campaigns') }}
          </el-button>
          <el-button size="mini" type="default" icon="el-icon-close" @click="show_dialog.shopee_result = false">
            {{ $t('base.close') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_keyword_price" :close-on-click-modal="false"
               width="800px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title"> {{ $t('base.mass_edit_x', {x: $t('base.bid_price')}) }} </strong>

        <el-row>
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="1">
              {{ $t('base.i_or_d_x_by_amount', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_cost" class="full-w"
                           :disabled="form_update_multiple_keyword_price.update_type !== 1">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_keyword_price.update_by_cost_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="2">
              {{ $t('base.i_or_d_x_by_percent', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_percent" class="full-w"
                           :disabled="form_update_multiple_keyword_price.update_type !== 2">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_keyword_price.update_by_percent_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="3">
              {{ $t('base.set_x', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                &nbsp;
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 3"
                          v-model="form_update_multiple_keyword_price.price"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <div style="margin-top: 10px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__update_keyword_price">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="save_keyword_file.show" :close-on-click-modal="false" custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('base.filename') }}</p>
        <el-input size="mini" :placeholder="$t('input.filename')"
                  v-model="save_keyword_file.filename"></el-input>
        <div style="padding-top:20px;" class="text-right">
          <el-button size="mini" icon="el-icon-close" @click="save_keyword_file.show=false">{{
              $t('base.close')
            }}
          </el-button>
          <el-button size="mini" icon="ti-save" :loading="save_keyword_file.loading" type="primary"
                     @click="m__try_save_keyword_file"> &nbsp; {{ $t('base.save_file') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" type="file"
           @change="m__import_excel_file" id="input_control_create" style="display: none;">
  </div>
</template>

<script>
import {orderBy as _orderBy, drop as _drop, take as _take, uniqBy as _uniqBy} from 'lodash'
import {FFF_COM_VN} from '../../addon/fff'
import readXlsxFile from 'read-excel-file'
import {ADS_CONSTANTS, make_uuid} from '../../addon/ads_function'
import {fix_ads_mixins} from "../../mixins/fix_ads";
import {package_mixins} from "../../mixins/package";

export default {
  mixins: [fix_ads_mixins, package_mixins],

  props: {
    shop: {},
    sp_user: {},
    product_list: {},
    get_products: false,
    ads_config: {},
    fff: null
  },

  data() {
    return {
      campaign_info: {
        name: '',
        tagline: '',
        budget_type: 'unlimited',
        daily_budget: 0,
        campaign_time: 'unlimited',
        campaign_date_range: [new Date(), new Date()],
        campaign_type: 'all',
        add_price_type: 'mipee',
        keyword_match_type: 'exact'
      },

      add_product_type: 'manual',
      config_campaign_price_type: 'manual',

      product_filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        total_record: 0,
        show: true
      },
      product_sort_option: {
        order: null,
        prop: null
      },

      product_selected_list: [],

      show_dialog: {
        select_product: false,
        update_keyword_price: false,
        shopee_result: false
      },
      loading: {
        create_campaign: false,
        shopee_suggest_keywords: false
      },

      advertisements: [
        {
          extinfo: {
            target: {
              price: null,
              base_price: null,
              premium_rate: 0
            }
          },
          itemid: '',
          placement: 2,
          rate: 0,
          status: 1
        },
        {
          extinfo: {
            target: {
              price: null,
              base_price: null,
              premium_rate: 0
            }
          },
          itemid: '',
          placement: 5,
          rate: 0,
          status: 1
        }
      ],

      form_update_target_broad_roi: {
        type: 'auto',
        custom_type: 'custom',
        custom_type_list: [6.1 * 100000, 9.1 * 100000, 11 * 100000],
        custom_value: null
      },

      // todo: old create search campaign data
      fff_sort_option: {
        order: null,
        prop: null
      },
      keyword_file_list: [],
      keyword: '',
      selected_keyword_file: '',
      mipee_suggest_keywords: [],
      shopee_suggest_keywords: [],
      mipee_filter: {
        page_size: 10,
        current_page: 0,
        sort_option: {
          order: null,
          prop: null
        },
      },
      shopee_filter: {
        page_size: 10,
        current_page: 0,
        sort_option: {
          order: null,
          prop: null
        },
      },
      type_product: 'all',
      category_list: [],
      selected_category: null,
      shop_category_list: [],
      selected_shop_category: null,
      radio: '1',
      search_keyword: [],
      search_keyword_filter: {
        page_size: 10,
        current_page: 0,
        sort_option: {
          order: null,
          prop: null
        },
      },
      atosa_keyword_filter: {
        page_size: 10,
        current_page: 0
      },
      added_keyword: [],
      added_keyword_filter: {
        page_size: 10,
        current_page: 0
      },
      form_update_multiple_keyword_price: {
        update_type: 3,
        update_by_cost: 'increase',
        update_by_percent: 'increase',
        update_by_suggest_cost: 'increase',
        update_by_suggest_percent: 'increase',
        update_by_cost_value: 0,
        update_by_percent_value: 0,
        update_by_suggest_cost_value: 1,
        update_by_suggest_percent_value: 1,
        cost_value: 0,
        match_type: 1,
        price: 0
      },
      base_keyword: '',
      fff_loading: false,
      fff_profile: {},
      fff_show: true,
      fff_result: [],
      fetch_loading: false,
      fetch_keyword: '',
      fff_clone: [],
      save_keyword_file: {
        show: false,
        loading: false,
        filename: 'Tệp keyword'
      },
      excel_keyword_filter: {
        page_size: 10,
        current_page: 0
      },
      excel_keyword: [],
      save_and_result_list: [],
      omit_duplicated_keyword: false,

      MATCH_TYPE_0_MIN: null, // TODO: exact
      MATCH_TYPE_1_MIN: null, // TODO: broad

      shopee_result: [],

      form_add_new_campaign: {
        price_type: 'shopee',
        match_type: 0
      },

      create_campaigns_result: []
    }
  },

  async beforeMount() {
    await this.m__get_keyword_file()
    await this.m__get_shopee_suggest_keywords()

    // todo: set ads config
    if (this.ads_config && this.ads_config.bid_price) {
      this.MATCH_TYPE_0_MIN = this.m__calculate(this.ads_config.bid_price.search_shop.exact_match.min / 100000)
      this.MATCH_TYPE_1_MIN = this.m__calculate(this.ads_config.bid_price.search_shop.broad_match.min / 100000)
      this.TARGETING_MIN = this.m__calculate(this.ads_config.bid_price.targeting.min / 100000)
      this.DAILY_BUDGET_MIN = this.m__calculate(this.ads_config.ads_config.product_ads.manual.search_product.min_daily_budget / 100000)
    }
  },

  computed: {
    c__product_filter_list() {
      let result = this.product_list

      result = result.filter(i => !this.product_selected_list.some(ii => ii.id === i.id))

      if (this.product_sort_option.order) {
        this.product_sort_option.order === 'ascending' && (result = _orderBy(result, [this.product_sort_option.prop], ['asc']))
        this.product_sort_option.order === 'descending' && (result = _orderBy(result, [this.product_sort_option.prop], ['desc']))
      }

      const keyword = this.remove_unicode(this.product_filter.keyword)
      return result.filter(i => i.id.toString().includes(keyword) || this.remove_unicode(i.name.normalize()).includes(this.remove_unicode(keyword)))
    },

    c__product_display_list() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)

      return _take(_drop(this.c__product_filter_list, skip), limit)
    },

    // todo: old create search campaign computed
    c__excel_keyword_display_list() {
      const limit = this.excel_keyword_filter.page_size
      const skip = limit * (this.excel_keyword_filter.current_page - 1)

      return _take(_drop(this.excel_keyword, skip), limit)
    },

    c__mipee_keywords_display_list() {
      let result = this.mipee_suggest_keywords

      if (this.mipee_filter.sort_option.order) {
        this.mipee_filter.sort_option.order === 'ascending' && (result = _orderBy(result, [this.mipee_filter.sort_option.prop], ['asc']))
        this.mipee_filter.sort_option.order === 'descending' && (result = _orderBy(result, [this.mipee_filter.sort_option.prop], ['desc']))
      }

      const limit = this.mipee_filter.page_size
      const skip = limit * (this.mipee_filter.current_page - 1)

      return _take(_drop(result, skip), limit)
    },

    c__shopee_keyword_display_list() {
      let result = this.shopee_suggest_keywords

      if (this.shopee_filter.sort_option.order) {
        this.shopee_filter.sort_option.order === 'ascending' && (result = _orderBy(result, [this.shopee_filter.sort_option.prop], ['asc']))
        this.shopee_filter.sort_option.order === 'descending' && (result = _orderBy(result, [this.shopee_filter.sort_option.prop], ['desc']))
      }

      const limit = this.shopee_filter.page_size
      const skip = limit * (this.shopee_filter.current_page - 1)

      return _take(_drop(result, skip), limit)
    },

    c__search_keyword_display_list() {
      let result = this.search_keyword

      if (this.search_keyword_filter.sort_option.order) {
        this.search_keyword_filter.sort_option.order === 'ascending' && (result = _orderBy(result, [this.search_keyword_filter.sort_option.prop], ['asc']))
        this.search_keyword_filter.sort_option.order === 'descending' && (result = _orderBy(result, [this.search_keyword_filter.sort_option.prop], ['desc']))
      }

      const limit = this.search_keyword_filter.page_size
      const skip = limit * (this.search_keyword_filter.current_page - 1)

      return _take(_drop(result, skip), limit)
    },

    c__added_keyword_display_list() {
      const limit = this.added_keyword_filter.page_size
      const skip = limit * (this.added_keyword_filter.current_page - 1)

      return _take(_drop(this.added_keyword, skip), limit)
    },

    c__fff_result_display_list() {
      const limit = this.atosa_keyword_filter.page_size
      const skip = limit * (this.atosa_keyword_filter.current_page - 1)

      let result = this.fff_result

      if (this.fff_sort_option.order) {
        this.fff_sort_option.order === 'ascending' && (result = _orderBy(result, [this.fff_sort_option.prop], ['asc']))
        this.fff_sort_option.order === 'descending' && (result = _orderBy(result, [this.fff_sort_option.prop], ['desc']))
      }

      return _take(_drop(result, skip), limit)
    }
  },

  methods: {
    async m__confirm_create_new_product_campaign() {
      this.create_campaigns_result = []

      if (!this.campaign_info.name) {
        this.ntf_w(this.$t('required.ad_name'))
        return
      }

      if (this.campaign_info.campaign_time === 'daterange') {
        if (!this.campaign_info.campaign_date_range[0] || !this.campaign_info.campaign_date_range[1]) {
          this.ntf_w(this.$t('required.ad_duration'))
          return
        }
        if (this.dayjs(this.campaign_info.campaign_date_range[0]).isAfter(this.campaign_info.campaign_date_range[1])) {
          this.ntf_w(this.ntf_w(this.$t('base.y_gt_than_x', {
            y: this.$t('base.start_time'),
            x: this.$t('base.end_time'),
          })))
          return
        }
      }

      if (this.config_campaign_price_type === 'manual' && !this.added_keyword.length) {
        this.ntf_w(this.$t('required.must_select_at_least_keyword'))
        return
      }

      try {
        await this.$confirm(this.$t('ads.update_budget_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.create_campaign = true

      // const check_duplicate_name_response = await this.sp_user.marketing_pas_check_duplicate_name({name: this.campaign_info.name})
      // if (check_duplicate_name_response && check_duplicate_name_response.data && check_duplicate_name_response.data.is_duplicate) {
      //   this.ntf_w(this.$t('ads.campaign_name_already_exists'))
      //   this.loading.create_campaign = false
      //   return
      // }

      try {
        const form = {
          reference_id: make_uuid(),
          campaign: {
            campaign_id: 0,
            target_broad_roi: 0,
            daily_budget: this.campaign_info.budget_type === 'unlimited' ? 0 : +this.campaign_info.daily_budget * 100000,
            creative: {
              is_use_default: !this.campaign_info.tagline,
              landing_page: 'shop_homepage',
              image_url: '',
              tagline: this.campaign_info.tagline
            },
            bidding_strategy: this.config_campaign_price_type,
            start_time: this.campaign_info.campaign_time === 'unlimited'
              ? this.dayjs().startOf('day').unix()
              : this.dayjs(this.campaign_info.campaign_date_range[0]).startOf('day').unix(),
            end_time: this.campaign_info.campaign_time === 'unlimited'
              ? 0
              : this.dayjs(this.campaign_info.campaign_date_range[1]).endOf('day').unix(),
            name: this.campaign_info.name
          },
          header: {}
        }

        if (this.config_campaign_price_type === 'manual') {
          form.campaign.bidding_strategy = 'manual'
          form.campaign.keyword_list = this.added_keyword.map(keyword => {
            keyword.match_type = this.form_add_new_campaign.match_type
            keyword.price = this.m__calculate(keyword.recommend_price)
            this.m__prefix_keyword_price(keyword)

            return {
              keyword: keyword.keyword.replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/g, '').trim().toLowerCase().normalize(),
              bid_price: keyword.price * 100000,
              match_type: keyword.match_type === 0 ? 'exact' : 'broad'
            }
          })

          const MAX_LENGTH = ADS_CONSTANTS.MAX_KEYWORDS_LENGTH
          form.campaign.keyword_list = _uniqBy(form.campaign.keyword_list, 'keyword').slice(0, MAX_LENGTH)
        }

        console.log(form)
        const create_response = await this.sp_user.marketing_pas_publish_campaign(form, 'shop')
        console.log(create_response)

        if (create_response.code === 0) {
          this.ntf_s(this.$t('base.create_campaign_success'))
        } else {
          this.ntf_w(this.$t('ads.error_with_creating_campaign') + '. ' + this.$t('base.error_code') + ': ' + (create_response.msg || create_response.message) + ', code:' + create_response.code)
        }

        // this.show_dialog.shopee_result = true
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.create_campaign = false
      }
    },

    m__back_to_list() {
      this.$emit('back_to_list')
    },

    m__product_sort_change({
                             prop,
                             order
                           }) {
      this.product_sort_option.order = order
      this.product_sort_option.prop = prop
    },

    m__show_select_product_dialog() {
      this.show_dialog.select_product = true
    },

    m__confirm_select_product() {
      this.product_selected_list.push(...this.c__product_filter_list.filter(i => i.checked))
      this.show_dialog.select_product = false

      this.m__get_shopee_suggest_keywords().catch(console.error)
    },

    // todo: old create search campaign
    async m__get_keyword_file() {
      const response = await this.$http.get(this.API.marketing.keyword_file.list, this.cf())
      this.keyword_file_list = response.body.data
    },

    async m__import_excel_file(event) {
      try {
        const file_store = event.target.files || event.dataTransfer.files
        if (file_store.length === 0) {
          return
        }

        const raw = await readXlsxFile(file_store[0])
        for (const row of raw) {
          if (row && row[0] && typeof row[0] === 'string' && !this.excel_keyword.some(i => i.keyword === row[0].toLowerCase())) {
            this.excel_keyword.push({
              keyword: row[0].toLowerCase(),
              recommend_price: row[1] && !Number.isNaN(+row[1]) ? +row[1] : null,
              search_volume: 0,
              algorithm: 'kwrcmdv2',
              input_price: row[1] && !Number.isNaN(+row[1]) ? +row[1] : null
            })
          }
        }

        if (this.excel_keyword.length) {
          try {
            const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
              mipeeUserId: this.$store.state.userInfo.username,
              keyword: this.excel_keyword[0].keyword,
              data: this.excel_keyword.map(i => i.keyword),
              country: this.sp_user.country
            }, this.cf())
            this.save_and_result_list = resp.body
          } catch (e) {
            console.error(e)
          }

          for (const keyword of this.excel_keyword) {
            if (keyword.recommend_price) continue

            const found = this.save_and_result_list.find(i => i.keyword === keyword.keyword)
            if (found) {
              keyword.search_volume = found.volume
              if (keyword.recommend_price === 0) keyword.recommend_price = this.m__calculate(found.recommendPrice)
            } else {
              const info = await this.sp_user.marketing_get_keyword_volume(keyword.keyword, this.product_list[0].id)
              keyword.search_volume = this.m__calculate(info.search_volume)
              keyword.algorithm = info.algorithm
              if (keyword.recommend_price === 0) keyword.recommend_price = this.m__calculate(info.recommend_price)
            }
          }
        }
      } catch (e) {
        console.log(e)
        this.ntf_w(this.$t('base.error_reading_file'))
      } finally {
        event.target.value = null
      }
    },

    m__show_import_excel_file() {
      this.$el.querySelector(`#input_control_create`).click()
    },

    m__is_allow_keyword_tool() {
      const extent_package = this.$store.state.package.extend_package ? this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing') : null
      if (extent_package) {
        return !!(this.dayjs().isBefore(this.dayjs(new Date(extent_package.license_to)), 's') &&
          extent_package.package.extra_data && extent_package.package.extra_data.marketing &&
          extent_package.package.extra_data.marketing.keyword_tool)
      } else {
        return false
      }
    },

    m__is_allow_delete_keyword() {
      const pack = this.$store.state.package && this.$store.state.package.extend_package && this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing')
      return pack && pack.package && pack.package.extra_data && pack.package.extra_data.marketing && pack.package.extra_data.marketing.delete_keyword
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },

    m__add_all() {
      let source = []

      if (this.radio === '1') {
        source = this.shopee_suggest_keywords
      }
      if (this.radio === '2') {
        const data = JSON.parse(JSON.stringify(this.mipee_suggest_keywords))
        source = data.map(i => {
          i.recommend_price = this.form_add_new_campaign.price_type === 'mipee' ? i.price : i.recommend_price
          return i
        })
      }
      if (this.radio === '3') {
        source = this.search_keyword
      }
      if (this.radio === '4') {
        source = this.fff_result.slice(0, 100)
      }
      if (this.radio === '5') {
        source = this.excel_keyword
      }

      if (source) {
        for (let i = 0; i < source.length; i++) {
          if (this.omit_duplicated_keyword) {
            if (!this.added_keyword.find(e => e.keyword.normalize() === source[i].keyword.normalize())) {
              this.added_keyword.push({
                ...source[i],
                recommend_price: source[i].input_price || source[i].recommend_price || this.MATCH_TYPE_0_MIN
              })
            }
          } else {
            if (!this.added_keyword.find(e => e.keyword === source[i].keyword)) {
              this.added_keyword.push({
                ...source[i],
                recommend_price: source[i].input_price || source[i].recommend_price || this.MATCH_TYPE_0_MIN
              })
            }
          }
        }
      }
    },

    m__can_add(item) {
      return !this.added_keyword.find(i => i.keyword === item.keyword)
    },

    m__add_keyword(item, source) {
      if (source === 'shopee_suggest_keywords') {
        this.added_keyword.push({
          keyword: item.keyword,
          recommend_price: item.input_price || item.recommend_price || this.MATCH_TYPE_0_MIN,
          sp_volume: item.search_volume || item.sp_volume || 0
        })
      } else if (source === 'mipee_suggest_keywords') {
        this.added_keyword.push({
          keyword: item.keyword,
          recommend_price: item.input_price || item.recommend_price || this.MATCH_TYPE_0_MIN,
          sp_volume: item.search_volume || item.sp_volume || 0
        })
      } else if (source === 'search_shopee_keywords') {
        this.added_keyword.push({
          keyword: item.keyword,
          recommend_price: item.input_price || item.recommend_price || this.MATCH_TYPE_0_MIN,
          sp_volume: item.search_volume || item.sp_volume || 0
        })
      } else {
        this.added_keyword.push({
          ...item,
          recommend_price: item.input_price || item.recommend_price || this.MATCH_TYPE_0_MIN
        })
      }
    },

    m__remove_keyword(keyword) {
      this.added_keyword = this.added_keyword.filter(i => i.keyword !== keyword.keyword)
    },

    m__remove_product(index) {
      if (!this.product_selected_list.length || this.product_selected_list.length === 1) {
        return
      }

      this.product_selected_list.splice(index, 1)
    },

    async m__suggest_keyword(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      let hint_keywords = await this.sp_user.marketing_get_hint_keyword(queryString)
      cb(hint_keywords.map(e => ({value: e.keyword})))
    },

    async m__search_sp_keyword(keyword) {
      this.search_keyword = []

      if (!keyword.value) {
        return
      }

      let suggest_keywords_resp = await this.sp_user.shop_ads_search_keywords(keyword.value)
      while (!suggest_keywords_resp || !suggest_keywords_resp.data) {
        await this.sleep(2000)
        suggest_keywords_resp = await this.sp_user.shop_ads_search_keywords(keyword.value)
      }

      for (const item of suggest_keywords_resp.data) {
        this.search_keyword.push({
          ...item,
          checked: false,
          sp_volume: item.search_volume,
          sp_price: this.m__calculate(item.recommend_price)
        })
      }
    },

    async m__get_sp_keyword_info(keyword) {
      try {
        let info = await this.sp_user.marketing_get_keyword_volume(keyword.keyword, this.product_list[0].id)
        if (info !== null) {
          keyword.sp_volume = info.search_volume
          keyword.sp_price = keyword.recommend_price = this.m__calculate(info.recommend_price)
        }
      } catch (e) {
      }
    },

    m__prefix_keyword_price(keyword) {
      if (!keyword.price) keyword.price = this.MATCH_TYPE_0_MIN

      if (keyword.match_type === 0 && keyword.price < this.MATCH_TYPE_0_MIN) {
        keyword.price = this.MATCH_TYPE_0_MIN
      }
      if (keyword.match_type === 1 && keyword.price < this.MATCH_TYPE_1_MIN) {
        keyword.price = this.MATCH_TYPE_1_MIN
      }
    },

    async m__get_keyword_file_detail() {
      const response = await this.$http.get(this.API.marketing.keyword_file.detail.replace('_id', this.selected_keyword_file), this.cf())
      for (const i of response.body.data.keyword_json) {
        i.search_volume = 0
        i.recommend_price = 0
      }
      this.mipee_suggest_keywords = response.body.data.keyword_json.map(i => {
        i.checked = true
        return i
      })

      for (const i of this.mipee_suggest_keywords) {
        await this.m__get_keyword_sp_info(i)
        await this.sleep(200)
      }
    },

    async m__get_keyword_sp_info(keyword) {
      try {
        let info = await this.sp_user.marketing_get_keyword_volume(keyword.keyword, null, 3)
        keyword.search_volume = info.search_volume
        keyword.recommend_price = this.m__calculate(info.recommend_price)
      } catch (error) {
        console.log(error)
      }
    },

    async m__get_shopee_suggest_keywords() {
      const response = await this.sp_user.shop_ads_get_suggest_keyword_price(null)
      if (response && response.data) {
        response.data.forEach(i => {
          i.recommend_price = this.m__calculate(i.recommend_price)
        })
        this.shopee_suggest_keywords.push(...response.data)
      }
      this.shopee_suggest_keywords = _uniqBy(this.shopee_suggest_keywords, 'keyword')
      this.loading.shopee_suggest_keywords = false
    },

    m__remove_shopee_keyword(keyword) {
      const index = this.shopee_suggest_keywords.findIndex(i => keyword === keyword)
      this.shopee_suggest_keywords.splice(index, 1)
    },

    async m__get_categories() {
      const response = await this.sp_user.get_categories()

      for (let i = 0; i < response.data.list.length; i++) {
        if (this.product_list.find(item => item.category_path && item.category_path[0] === response.data.list[i].id)) {
          this.category_list.push(response.data.list[i])
        }
      }

      if (this.category_list.length) {
        this.selected_category = this.category_list[0].id
      }
    },

    async m__get_shop_categories() {
      const response = await this.sp_user.get_shop_categories()
      if (response.data && response.data.list) {
        this.shop_category_list = response.data.list
      }
      if (this.shop_category_list.length) {
        this.selected_shop_category = this.shop_category_list[0].id
      }
    },

    m__show_update_keyword_dialog() {
      this.show_dialog.update_keyword_price = true
    },

    m__update_keyword_price() {
      if (this.form_update_multiple_keyword_price.update_type === 1 && this.form_update_multiple_keyword_price.update_by_cost_value) {
        this.added_keyword.forEach(i => {
          if (this.form_update_multiple_keyword_price.update_by_cost === 'increase') {
            i.recommend_price += this.m__calculate(this.form_update_multiple_keyword_price.update_by_cost_value)
          }

          if (this.form_update_multiple_keyword_price.update_by_cost === 'reduce') {
            i.recommend_price -= this.m__calculate(this.form_update_multiple_keyword_price.update_by_cost_value)
          }
        })
      }

      if (this.form_update_multiple_keyword_price.update_type === 2 && this.form_update_multiple_keyword_price.update_by_percent_value) {
        this.added_keyword.forEach(i => {
          if (this.form_update_multiple_keyword_price.update_by_percent === 'increase') {
            i.recommend_price += (i.recommend_price * this.m__calculate(this.form_update_multiple_keyword_price.update_by_percent_value) / 100)
          }

          if (this.form_update_multiple_keyword_price.update_by_percent === 'reduce') {
            i.recommend_price -= (i.recommend_price * this.m__calculate(this.form_update_multiple_keyword_price.update_by_percent_value) / 100)
          }
        })
      }

      if (this.form_update_multiple_keyword_price.update_type === 3) {
        this.added_keyword.forEach(i => {
          i.recommend_price = this.m__calculate(this.form_update_multiple_keyword_price.price)
        })
      }

      this.show_dialog.update_keyword_price = false
    },

    async m__enter_input() {
      if (!this.fff_loading) {
        await this.m__try_get_keyword_result()
      }
    },

    async m__try_get_keyword_result() {
      this.fff_loading = true
      let keyword_list = await this.m__get_suggestion_keyword(this.base_keyword)
      let result = await this.fff.get_keyword_result(keyword_list, 5000, this.base_keyword)
      if (result === null) {
        await this.$nextTick(() => {
          this.ntf_w(this.$t('keyword.error_while_get_data'))
        })
      } else if (!result.data.keywords || !result.data.keywords.length || result.data.keywords.length < 30) {
        this.ntf_w(`${this.$t('base.keywords_result_not_found')} "${this.base_keyword}"`)
      } else {
        let temp = result.data.keywords.map(e => {
          return {
            ...e,
            results: Math.round(e.results) || 0,
            checked: false,
            sp_volume: 0,
            loading: false,
            sp_price: 0
          }
        })
        if (!temp.some(i => i.keyword === this.base_keyword)) {
          const base_item = {
            keyword: this.base_keyword,
            results: 0,
            sp_volume: 0,
            sp_price: 0,
            relevance: 0,
            checked: false,
            loading: false
          }
          temp.unshift(base_item)
        }

        if (temp[0].keyword !== this.base_keyword) {
          const index = temp.findIndex(i => i.keyword === this.base_keyword)
          const temp_item = temp[index]
          temp.splice(index, 1)
          temp.unshift(temp_item)
        }

        const first = temp.shift()
        this.fff_result = _take(_orderBy(temp, ['results'], ['desc']), 500)
        this.fff_result.unshift(first)

        const keyword = this.base_keyword
        const extend_resp = await this.sp_user.shop_ads_search_keywords(keyword)
        if (extend_resp && extend_resp.data) {
          let index_splice = 1
          for (const item of extend_resp.data) {
            if (this.contain_at_least(keyword, item.keyword)) {
              const keyword = {
                keyword: item.keyword,
                results: 0,
                sp_volume: item.search_volume,
                sp_price: item.recommend_price,
                relevance: item.relevance,
                checked: false,
                loading: false
              }
              this.fff_result.splice(index_splice++, 0, keyword)
            }
          }
        }

        try {
          const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
            mipeeUserId: this.$store.state.userInfo.username,
            keyword: this.base_keyword,
            data: this.fff_result.map(i => i.keyword),
            country: this.sp_user.country
          }, this.cf())
          this.save_and_result_list = resp.body
        } catch (e) {
          console.error(e)
        }

        for (const item of this.fff_result) {
          item.keyword = item.keyword.normalize()
        }
        this.result = _uniqBy(this.fff_result, 'keyword')

        this.fetch_index = 0
        this.fetch_keyword = this.base_keyword
        await this.m__start_get_sp_keyword()
      }

      this.fff_loading = false
    },

    async m__start_get_sp_keyword() {
      this.fetch_loading = true

      for (const item of this.fff_result) {
        if (this.fetch_keyword !== this.base_keyword) {
          break
        }

        if (item.sp_volume && item.sp_price) continue

        const found = this.save_and_result_list.find(i => i.keyword === item.keyword)
        if (found) {
          item.relevance = found.relevance
          item.sp_volume = found.volume
          item.sp_price = item.recommend_price = this.m__calculate(found.recommendPrice)
        } else {
          await this.m__get_sp_keyword_info(item)
        }
      }

      this.fff_clone = JSON.parse(JSON.stringify(this.fff_result))
      this.fetch_loading = false
    },

    async m__get_suggestion_keyword(keyword) {
      const product_id = this.product_list[0] ? this.product_list[0].id : null
      const hint_keywords = await this.sp_user.marketing_list_keyword_hint(keyword, product_id, 0)
      return hint_keywords.data.map(i => i.keyword)
    },

    m__initial_save_keyword_file() {
      if (!this.m__is_allow_keyword_tool()) {
        this.ntf_w(this.$t('package.not_for_trial'))
        return
      }

      if (this.added_keyword.length > 0) {
        this.save_keyword_file.filename = `${this.$t('keyword.file')} ${this.added_keyword[0].keyword} (${this.added_keyword.length} ${this.$t('base.keyword')} - ${this.$t('base.at')} ${this.timeFormat(new Date())})`
        this.save_keyword_file.show = true
      } else {
        this.ntf_w(this.$t('keyword.empty_to_save'))
      }
    },

    m__try_save_keyword_file() {
      this.confirm(this.$t('keyword.confirm_save_file_x_name', {x: this.save_keyword_file.filename}), () => {
        this.save_keyword_file.loading = true

        this.$http.post(this.API.marketing.keyword_file.add, {
          filename: this.save_keyword_file.filename,
          keyword_json: this.added_keyword.map(i => {
            return {
              checked: true,
              keyword: i.keyword,
              keyword_source_type: 0,
              price: i.recommend_price,
              record_type: 0,
              rnum: 0,
              sp_price: i.recommend_price,
              sp_volume: i.sp_volume
            }
          })
        }, this.cf())
          .then(async (resp) => {
            this.ntf_s(resp)
            this.save_keyword_file.loading = false
            this.save_keyword_file.show = false

            this.$emit('m__reload_saved_keyword')
          })
          .catch(error => {
            console.log(error)
            this.ntf_w(error)
            this.save_keyword_file.loading = false
          })
      })
    },

    m__fff_sort_change({
                         prop,
                         order
                       }) {
      this.fff_sort_option.order = order
      this.fff_sort_option.prop = prop
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/create_shop.vue